import { z } from 'zod';

// Setarile ne-secrete din ops.settings, editate din Pluto (docs/21). Aceleasi reguli ca in
// private.valid_setting (migrarea 20261104100000_pluto.sql, marcajul contracts:SETTINGS); testul
// contracts/test/sql-sync.test.ts pica daca difera. Secretele NU stau aici (docs/16 §13).

export interface SettingSpec {
  schema: z.ZodType;
  label: string;
  help: string;
  /** Pentru testul de sincronizare: tipul si intervalul, ca in SQL. */
  sql: string;
}

export const SETTINGS = {
  'extraction.paused': {
    schema: z.boolean(),
    label: 'Extragerea e în pauză',
    help: 'Programările nu mai pun joburi în coadă, iar worker-ul nu mai ia joburi noi.',
    sql: 'boolean',
  },
  'logs.retention_days': {
    schema: z.number().int().min(7).max(365),
    label: 'Retenția logurilor (zile)',
    help: 'Cât rămân avertismentele și erorile în ops.logs (VictoriaLogs are 30 de zile).',
    sql: 'integer 7..365',
  },
  'jobs.max_attempts': {
    schema: z.number().int().min(1).max(10),
    label: 'Încercări pe job',
    help: 'După atâtea eșecuri, jobul trece în eroare și ajunge în DLQ.',
    sql: 'integer 1..10',
  },
} as const satisfies Record<string, SettingSpec>;

export type SettingKey = keyof typeof SETTINGS;
export const SETTING_KEYS = Object.keys(SETTINGS) as SettingKey[];

/** Valideaza o valoare inainte de admin_api.set_setting. */
export function parseSetting(key: SettingKey, value: unknown) {
  return SETTINGS[key].schema.safeParse(value);
}
